import moment from 'moment';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { withTranslation } from "react-i18next";
import ESRSSidebar from './ESRSSidebar';
import './ESRS.scss';
import logo from '../../../../images/Ecodrisil_logo.png'
import coverImg from '../../../../images/Cover-image-1-1280x720.jpg'
import ClimateChangeImg from '../../../../images/ClimateChange.png'
import environmentImg from '../../../../images/environment.png'
import { BsBuildings, BsGearWideConnected } from "react-icons/bs";
const ESRSContainer = ({ t }) => {


    return (
        <div className="ESRS_mainBox_horizontal" >
            {/* <ESRSSidebar /> */}
            <div className='ESRS_MainSection'>
                <section className='ESRSsection'>
                    <div className='coverPagebox'>
                        <div className='cover_imgBox'>
                            <img src={coverImg} />
                        </div>
                        <div className='coverPagebox_details'>
                            <div className='campany_logobox'>
                                <img src={logo} />
                            </div>
                            <div>
                                <h2>FY 2024</h2>
                                <h3>
                                    European Sustainability <br></br> Reporting Standards <br></br> (ESRS)
                                </h3>
                            </div>

                            <div className='campany_NameBox'>
                                {/* Ethical Edge Solutions LLC */}
                            </div>
                        </div>
                    </div>

                    <section className='ESRSsectionCard'>
                        <div className='ESRSsectionCard_inner'>
                            <div className='ESRSsectionCard_head mb-5'>
                                <h3>Table of Contents</h3>
                            </div>
                            <div className='row m-0'>
                                <div className='col-md-4 p-2 ESRS_introductionbox'>
                                    <div className='icon_box_ESRS'>
                                        <BsBuildings />
                                    </div>
                                    <div>
                                        <h5>introduction</h5>
                                        <ul>
                                            <li>
                                                Introduction
                                            </li>
                                            <li>
                                                About this report
                                            </li>
                                            <li>
                                                About us
                                            </li>
                                            <li>
                                                Our progress so far
                                            </li>
                                            <li>
                                                Message from our Management
                                            </li>
                                            <li>
                                                Our EcoVadis rating
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className='col-md-4 p-2 ESRS_introductionbox'>
                                    <div className='icon_box_ESRS'>
                                        <BsGearWideConnected />
                                    </div>
                                    <div>
                                        <h5>General Disclosures</h5>
                                        <ul>
                                            <li>
                                                Basis for  preparation
                                            </li>
                                            <li>
                                                Governance
                                            </li>
                                            <li>
                                                Strategy
                                            </li>
                                            <li>
                                                Impact risk
                                                and opportunity
                                                management
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                                <div className='col-md-4 p-2 ESRS_introductionbox'>
                                    <div className='icon_box_ESRS'>
                                        <img src={environmentImg} />
                                    </div>
                                    <div>
                                        <h5> Environment</h5>
                                        <ul>
                                            <li>
                                                <a href='#'>ESRS E1: Climate change</a>
                                            </li>
                                            <li>
                                                <a href='#'>ESRS E2: Pollution</a>
                                            </li>
                                            <li>
                                                <a href='#'> ESRS E3: Water and marine  resources</a>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className='ESRSsectionCard content_titles Environment'>
                        <div className='ESRSsectionCard_inner'>
                            <div className='ESRSsectionCard_head'>
                                <h3>Environment</h3>
                            </div>
                            <div className='row mx-0 mt-3'>
                                <div className='col-md-6 p-2'>
                                    <div className='ESRS_fileName'>
                                        <h6>ESRS E1: CLIMATE CHANGE </h6>
                                    </div>
                                    <div>
                                        <h5>Governance</h5>
                                        <ul>
                                            <li>
                                                <span>ESRS 2 GOV-3 </span>Integration of sustainability-related performance in incentive schemes
                                            </li>
                                        </ul>
                                    </div>
                                    <div>
                                        <h5>Strategy</h5>
                                        <ul>
                                            <li>
                                                <span> E1-1</span> Transition plan for climate change mitigation
                                            </li>
                                            <li>
                                                <span>  ESRS 2 SBM-3</span> Material impacts, risks and opportunities and their interaction with strategy and business model
                                            </li>
                                        </ul>
                                    </div>
                                    <div>
                                        <h5> Impact, risk and opportunity management</h5>
                                        <ul>
                                            <li>
                                                <span>ESRS 2 IRO-1</span>Description of the processes to identify and assess material climate-related impacts, risks and opportunities
                                            </li>
                                            <li>
                                                <span>E1-2</span>Policies related to climate change mitigation and adaptation
                                            </li>
                                            <li>
                                                <span>E1-3</span>Actions and resources in relation to climate change policies
                                            </li>
                                        </ul>
                                    </div>
                                    <div>
                                        <h5>Metrics and targets</h5>
                                        <ul>
                                            <li>
                                                <span>E1-4</span>gets related to climate change mitigation and adaptation
                                            </li>
                                            <li><span>E1-5</span>Energy consumption and mix</li>
                                            <li><span>E1-6</span>Gross Scopes 1, 2, 3 and Total GHG emissions	</li>
                                            <li><span>E1-7</span>GHG removals and GHG mitigation projects financed through carbon credits	 </li>
                                            <li><span>E1-8</span>Internal carbon pricing</li>
                                            <li><span>E1-9</span>Anticipated financial effects from material physical and transition risks and potential climate-related opportunities	 </li>
                                            <li><span>E1-8</span>Internal carbon pricing	 </li>
                                            <li><span>E1-9</span>Anticipated financial effects from material physical and transition risks and potential climate-related opportunities </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className='ESRSsectionCard content_titles'>
                        <div className='ESRSsectionCard_inner'>
                            <div className='ESRSsectionCard_head'>
                                <h3>Social </h3>
                            </div>
                            <div className='row mx-0 mt-5'>
                                <div className='col-md-6 p-2'>
                                    <div>
                                        <h5>Governance</h5>
                                        <ul>
                                            <li>
                                                <span>ESRS 2 GOV-3 </span>Integration of sustainability-related performance in incentive schemes
                                            </li>
                                        </ul>
                                    </div>
                                    <div>
                                        <h5>Strategy</h5>
                                        <ul>
                                            <li>
                                                <span> E1-1</span> Transition plan for climate change mitigation
                                            </li>
                                            <li>
                                                <span>  ESRS 2 SBM-3</span> Material impacts, risks and opportunities and their interaction with strategy and business model
                                            </li>
                                        </ul>
                                    </div>
                                    <div>
                                        <h5> Impact, risk and opportunity management</h5>
                                        <ul>
                                            <li>
                                                <span>ESRS 2 IRO-1</span>Description of the processes to identify and assess material climate-related impacts, risks and opportunities
                                            </li>
                                            <li>
                                                <span>E1-2</span>Policies related to climate change mitigation and adaptation
                                            </li>
                                            <li>
                                                <span>E1-3</span>Actions and resources in relation to climate change policies
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                                <div className='col-md-6 p-2'>

                                    <div>
                                        <h5>Metrics and targets</h5>
                                        <ul>
                                            <li>
                                                <span>E1-4</span>gets related to climate change mitigation and adaptation
                                            </li>
                                            <li><span>E1-5</span>Energy consumption and mix</li>
                                            <li><span>E1-6</span>Gross Scopes 1, 2, 3 and Total GHG emissions	</li>
                                            <li><span>E1-7</span>GHG removals and GHG mitigation projects financed through carbon credits	 </li>
                                            <li><span>E1-8</span>Internal carbon pricing</li>
                                            <li><span>E1-9</span>Anticipated financial effects from material physical and transition risks and potential climate-related opportunities	 </li>
                                            <li><span>E1-8</span>Internal carbon pricing	 </li>
                                            <li><span>E1-9</span>Anticipated financial effects from material physical and transition risks and potential climate-related opportunities </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className='ESRSsectionCard content_titles Governance'>
                        <div className='ESRSsectionCard_inner'>
                            <div className='ESRSsectionCard_head'>
                                <h3>Governance </h3>
                            </div>
                            <div className='row mx-0 mt-5'>
                                <div className='col-md-6 p-2'>
                                    <div>
                                        <h5>Governance</h5>
                                        <ul>
                                            <li>
                                                <span>ESRS 2 GOV-3 </span>Integration of sustainability-related performance in incentive schemes
                                            </li>
                                        </ul>
                                    </div>
                                    <div>
                                        <h5>Strategy</h5>
                                        <ul>
                                            <li>
                                                <span> E1-1</span> Transition plan for climate change mitigation
                                            </li>
                                            <li>
                                                <span>  ESRS 2 SBM-3</span> Material impacts, risks and opportunities and their interaction with strategy and business model
                                            </li>
                                        </ul>
                                    </div>
                                    <div>
                                        <h5> Impact, risk and opportunity management</h5>
                                        <ul>
                                            <li>
                                                <span>ESRS 2 IRO-1</span>Description of the processes to identify and assess material climate-related impacts, risks and opportunities
                                            </li>
                                            <li>
                                                <span>E1-2</span>Policies related to climate change mitigation and adaptation
                                            </li>
                                            <li>
                                                <span>E1-3</span>Actions and resources in relation to climate change policies
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                                <div className='col-md-6 p-2'>

                                    <div>
                                        <h5>Metrics and targets</h5>
                                        <ul>
                                            <li>
                                                <span>E1-4</span>gets related to climate change mitigation and adaptation
                                            </li>
                                            <li><span>E1-5</span>Energy consumption and mix</li>
                                            <li><span>E1-6</span>Gross Scopes 1, 2, 3 and Total GHG emissions	</li>
                                            <li><span>E1-7</span>GHG removals and GHG mitigation projects financed through carbon credits	 </li>
                                            <li><span>E1-8</span>Internal carbon pricing</li>
                                            <li><span>E1-9</span>Anticipated financial effects from material physical and transition risks and potential climate-related opportunities	 </li>
                                            <li><span>E1-8</span>Internal carbon pricing	 </li>
                                            <li><span>E1-9</span>Anticipated financial effects from material physical and transition risks and potential climate-related opportunities </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className='ESRSsectionCard ESRSsectionCard_content'>
                        <div className='ESRSsectionCard_inner '>
                            <div className='row m-0'>
                                <div className='col-md-3 p-2 pe-3'>
                                    <div className='ESRSsectionCard_contenthead'>
                                        <h3>ESRS E1</h3>
                                        <h4>Climate change</h4>
                                        <img src={ClimateChangeImg} />
                                    </div>
                                    <div className='p-4'>
                                        <h6 className='m-0'>
                                            As the global climate crisis continues,
                                            and its effects become increasingly
                                            visible, we remain committed to being
                                            part of the solution.
                                        </h6>
                                    </div>
                                </div>
                                <div className='col-md-9 p-0'>
                                    <div className='row m-0'>
                                        <div className='col-md-4 p-2'>
                                            <div className='mb-3'>
                                                <h5>
                                                    Governance
                                                </h5>
                                                <strong>ESRS 2 GOV-3 Integration of sustainability-related performance in incentive schemes </strong>
                                            </div>
                                            <div>
                                                <ul>
                                                    <li>
                                                        Disclosure of whether and how climate-related considerations are factored into remuneration of members of administrative, management and supervisory bodies
                                                        <p className='my-2'>Answer entered for E1.GOV-3_01</p>
                                                    </li>
                                                    <li>
                                                        Percentage of remuneration recognised that is linked to climate related considerations
                                                        <p className='my-2'>Answer entered for E1.GOV-3_02</p>
                                                    </li>
                                                    <li>
                                                        Explanation of climate-related considerations that are factored into remuneration of members of administrative, management and supervisory bodies
                                                        <p className='my-2'>Answer entered for E1.GOV-3_03</p>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className='mb-3'>
                                                <h5>
                                                    Strategy
                                                </h5>
                                                <strong>
                                                    Disclosure Requirement E1-1 – Transition plan for climate change mitigation
                                                </strong>
                                            </div>
                                            <div>
                                                <ul>
                                                    <li>
                                                        Disclosure of transition plan for climate change mitigation
                                                        <p>Answer entered for E1-1_01</p>
                                                    </li>
                                                    <li>
                                                        Explanation of how targets are compatible with limiting of global warming to one and half degrees Celsius in line with Paris Agreement
                                                        <p>Answer entered for E1-1_02</p>
                                                    </li>
                                                    <li>
                                                        Disclosure of decarbonisation levers and key action
                                                        <p>Answer entered for E1-1_03</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className='col-md-4 p-2'>
                                            <table className='table table-bordered'>
                                                <thead>
                                                    <tr>
                                                        <th>Decarbonisation levers </th>
                                                        <th>Key action  </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <div>
                                                <ul>
                                                    <li>
                                                        Disclosure of significant operational expenditures (Opex) and (or) capital expenditures (Capex) required for implementation of action plan
                                                        <p>Answer entered for E1-1_04</p>
                                                    </li>
                                                    <li>
                                                        Financial resources allocated to action plan (OpEx):
                                                        <table className='table table-bordered'>
                                                            <thead>
                                                                <tr>
                                                                    <th>Action Plan (Opex) </th>
                                                                    <th>Financial Resources allocated </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Answer entered for E1-1_05 </td>
                                                                    <td>Answer entered for E1-1_05 </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Answer entered for E1-1_05 </td>
                                                                    <td>Answer entered for E1-1_05 </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Answer entered for E1-1_05 </td>
                                                                    <td>Answer entered for E1-1_05 </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </li>
                                                    <li>
                                                        Financial resources allocated to action plan (CapEx):
                                                        <table className='table table-bordered'>
                                                            <thead>
                                                                <tr>
                                                                    <th>Action Plan (Capex) </th>
                                                                    <th>Financial Resources allocated </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Answer entered for E1-1_06 </td>
                                                                    <td>Answer entered for E1-1_06 </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Answer entered for E1-1_06 </td>
                                                                    <td>Answer entered for E1-1_06 </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Answer entered for E1-1_06 </td>
                                                                    <td>Answer entered for E1-1_06 </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </li>
                                                </ul>
                                            </div>

                                        </div>
                                        <div className='col-md-4 p-2'>
                                            <div>
                                                <ul>
                                                    <li>
                                                        Explanation of potential locked-in GHG emissions from key assets and products and of how locked-in GHG emissions may jeopardise achievement of GHG emission reduction targets and drive transition risk
                                                        <p>Answer entered for E1-1_07	 </p>
                                                    </li>
                                                    <li>
                                                        Explanation of any objective or plans (CapEx, CapEx plans, OpEx) for aligning economic activities (revenues, CapEx, OpEx) with criteria established in Commission Delegated Regulation 2021/2139
                                                        <p>Answer entered for E1-1_08 </p>
                                                    </li>
                                                    <li>
                                                        Significant CapEx for coal-related economic activities
                                                        <p>Answer entered for E1-1_09</p>
                                                    </li>
                                                    <li>
                                                        Significant CapEx for oil-related economic activities
                                                        <p>Answer entered for E1-1_10</p>
                                                    </li>
                                                    <li>
                                                        Significant CapEx for gas-related economic activities
                                                        <p>Answer entered for E1-1_11</p>
                                                    </li>
                                                    <li>
                                                        Undertaking is excluded from EU Paris-aligned Benchmarks
                                                        <p>Answer entered for E1-1_12</p>
                                                    </li>
                                                    <li>
                                                        Explanation of how transition plan is embedded in and aligned with overall business strategy and financial planning
                                                        <p>Answer entered for E1-1_13</p>
                                                    </li>
                                                    <li>
                                                        Transition plan is approved by administrative, management and supervisory bodies
                                                        <p>Answer entered for E1-1_14</p>
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>
                    <section className='ESRSsectionCard ESRSsectionCard_content'>
                        <div className='ESRSsectionCard_inner '>
                            <div className='row m-0'>
                                <div className='col-md-12 p-0'>
                                    <div className='row m-0'>
                                        <div className='col-md-3 p-2'>
                                            <div className='mb-3'>
                                                <h5>
                                                    Governance
                                                </h5>
                                                <strong>ESRS 2 GOV-3 Integration of sustainability-related performance in incentive schemes </strong>
                                            </div>
                                            <div>
                                                <ul>
                                                    <li>
                                                        Disclosure of whether and how climate-related considerations are factored into remuneration of members of administrative, management and supervisory bodies
                                                        <p className='my-2'>Answer entered for E1.GOV-3_01</p>
                                                    </li>
                                                    <li>
                                                        Percentage of remuneration recognised that is linked to climate related considerations
                                                        <p className='my-2'>Answer entered for E1.GOV-3_02</p>
                                                    </li>
                                                    <li>
                                                        Explanation of climate-related considerations that are factored into remuneration of members of administrative, management and supervisory bodies
                                                        <p className='my-2'>Answer entered for E1.GOV-3_03</p>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className='mb-3'>
                                                <h5>
                                                    Strategy
                                                </h5>
                                                <strong>
                                                    Disclosure Requirement E1-1 – Transition plan for climate change mitigation
                                                </strong>
                                            </div>
                                            <div>
                                                <ul>
                                                    <li>
                                                        Disclosure of transition plan for climate change mitigation
                                                        <p>Answer entered for E1-1_01</p>
                                                    </li>
                                                    <li>
                                                        Explanation of how targets are compatible with limiting of global warming to one and half degrees Celsius in line with Paris Agreement
                                                        <p>Answer entered for E1-1_02</p>
                                                    </li>
                                                    <li>
                                                        Disclosure of decarbonisation levers and key action
                                                        <p>Answer entered for E1-1_03</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className='col-md-3 p-2'>
                                            <table className='table table-bordered'>
                                                <thead>
                                                    <tr>
                                                        <th>Decarbonisation levers </th>
                                                        <th>Key action  </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <div>
                                                <ul>
                                                    <li>
                                                        Disclosure of significant operational expenditures (Opex) and (or) capital expenditures (Capex) required for implementation of action plan
                                                        <p>Answer entered for E1-1_04</p>
                                                    </li>
                                                    <li>
                                                        Financial resources allocated to action plan (OpEx):
                                                        <table className='table table-bordered'>
                                                            <thead>
                                                                <tr>
                                                                    <th>Action Plan (Opex) </th>
                                                                    <th>Financial Resources allocated </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Answer entered for E1-1_05 </td>
                                                                    <td>Answer entered for E1-1_05 </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Answer entered for E1-1_05 </td>
                                                                    <td>Answer entered for E1-1_05 </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Answer entered for E1-1_05 </td>
                                                                    <td>Answer entered for E1-1_05 </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </li>
                                                    <li>
                                                        Financial resources allocated to action plan (CapEx):
                                                        <table className='table table-bordered'>
                                                            <thead>
                                                                <tr>
                                                                    <th>Action Plan (Capex) </th>
                                                                    <th>Financial Resources allocated </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Answer entered for E1-1_06 </td>
                                                                    <td>Answer entered for E1-1_06 </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Answer entered for E1-1_06 </td>
                                                                    <td>Answer entered for E1-1_06 </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Answer entered for E1-1_06 </td>
                                                                    <td>Answer entered for E1-1_06 </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </li>
                                                </ul>
                                            </div>

                                        </div>
                                        <div className='col-md-3 p-2'>
                                            <div>
                                                <ul>
                                                    <li>
                                                        Explanation of potential locked-in GHG emissions from key assets and products and of how locked-in GHG emissions may jeopardise achievement of GHG emission reduction targets and drive transition risk
                                                        <p>Answer entered for E1-1_07	 </p>
                                                    </li>
                                                    <li>
                                                        Explanation of any objective or plans (CapEx, CapEx plans, OpEx) for aligning economic activities (revenues, CapEx, OpEx) with criteria established in Commission Delegated Regulation 2021/2139
                                                        <p>Answer entered for E1-1_08 </p>
                                                    </li>
                                                    <li>
                                                        Significant CapEx for coal-related economic activities
                                                        <p>Answer entered for E1-1_09</p>
                                                    </li>
                                                    <li>
                                                        Significant CapEx for oil-related economic activities
                                                        <p>Answer entered for E1-1_10</p>
                                                    </li>
                                                    <li>
                                                        Significant CapEx for gas-related economic activities
                                                        <p>Answer entered for E1-1_11</p>
                                                    </li>
                                                    <li>
                                                        Undertaking is excluded from EU Paris-aligned Benchmarks
                                                        <p>Answer entered for E1-1_12</p>
                                                    </li>
                                                    <li>
                                                        Explanation of how transition plan is embedded in and aligned with overall business strategy and financial planning
                                                        <p>Answer entered for E1-1_13</p>
                                                    </li>
                                                    <li>
                                                        Transition plan is approved by administrative, management and supervisory bodies
                                                        <p>Answer entered for E1-1_14</p>
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>

                    <div className='BackcoverPagebox'>
                        <div className='cover_imgBox'>
                            <img src={coverImg} />
                        </div>
                        <div className='BackcoverPagebox_details'>
                            <div className='campany_logobox'>
                                <img src={logo} />
                            </div>
                            <div>
                                <h2>FY 2024</h2>
                                <h3>
                                    European Sustainability <br></br> Reporting Standards <br></br> (ESRS)
                                </h3>
                            </div>

                            <div className='campany_NameBox'>
                                {/* Ethical Edge Solutions LLC */}
                            </div>
                        </div>
                    </div>


                </section>




            </div>
        </div >
    );
}

export default withTranslation()(ESRSContainer);